import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      meta: { title: '首页 - 益华通盛' },
      component: () => import('./views/Home.vue')
    },
    {
      path: '/news',
      name: 'news',
      meta: { title: '云平台 - 益华通盛' },
      component: () => import('./views/News.vue')
    },
    {
      path: '/newsdetails/:id',
      name: 'newsdetails',
      meta: { title: '新闻详情 - 益华通盛' },
      component: () => import('./views/NewsDetails.vue')
    },
    {
      path: '/product',
      name: 'product',
      meta: { title: '产品介绍 - 益华通盛' },
      component: () => import('./views/Product.vue')
    },
    {
      path: '/case',
      name: 'case',
      meta: { title: '产品列表 - 益华通盛' },
      component: () => import('./views/Case.vue')
    },
    {
      path: '/casedetails/:id',
      name: 'casedetails',
      meta: { title: '产品详情 - 益华通盛' },
      component: () => import('./views/CaseDetails.vue')
    },
    {
      path: '/goin',
      name: 'goin',
      meta: { title: '走进益华通盛 - 益华通盛' },
      component: () => import('./views/GoIn.vue')
    },
    {
      path: '/download',
      name: 'download',
      meta: { title: '下载小程序 - 益华通盛' },
      component: () => import('./views/Download.vue')
    },
    {
      path: '/login',
      name: 'login',
      meta: { title: '登录 - 益华通盛' },
      component: () => import('./views/Login.vue')
    },
    {
      path: '*',
      name: 'notfound',
      meta: { title: '页面未找到 - 益华通盛' },
      component: () => import('./views/NotFound.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
